import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import { Form } from '@/components/ui/form'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { actions } from '../Customers/customers.slice'
import {
	selectUsers,
	selectSelectedRow,
	selectSelectedAccountId,
} from '../Customers/customers.selectors'
import {
	deleteCustomerUser,
	fetchCustomerUsers,
} from '../Customers/customers.asynActions'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { object as YupObject, string as YupString } from 'yup'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import TextField from '@/components/forms/text-field'
import SelectField from '@/components/forms/select-field'

const { setSelectedCustomerModal, setSelectedRow } = actions

const DeleteUserModal = () => {
	const dispatch = useDispatch()
	const resetModal = () => {
		dispatch(setSelectedCustomerModal(null))
		dispatch(setSelectedRow({}))
	}

	const userData = useSelector(selectUsers)
	const accountId = useSelector(selectSelectedAccountId)
	const selectedUser = useSelector(selectSelectedRow)

	const moveAssignmentTo = userData.filter(
		(each) => each.id !== selectedUser.id
	)

	useEffect(() => {
		dispatch(showModal())
	}, [dispatch])
	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
	}

	const validationSchema = YupObject().shape({
		userName: YupString()
			.required('User Name is Required')
			.matches(selectedUser.userName, 'User name does not match'),
	})

	const form = useForm({
		resolver: yupResolver(validationSchema),
		defaultValues: { userName: '', moveAssignment: '' },
	})

	const onSubmit = async (values) => {
		const result = await dispatch(
			deleteCustomerUser({
				userId: selectedUser.id,
				data: { newId: values.moveAssignment },
			})
		)
		if (result?.payload) {
			dispatch(fetchCustomerUsers({ id: accountId, useCaching: false }))
		}
		dispatch(setSelectedCustomerModal(null))
		form.reset()
	}
	
	const { isSubmitting } = form.formState

	return (
		<Form {...form}>
			<Modal
				footer={
					<>
						<Button
							className='h-50 w-190'
							variant='outline'
							onClick={handleClose}
						>
							Cancel
						</Button>
						<Button
							className='h-50 w-190'
							onClick={form.handleSubmit(onSubmit)}
							disabled={isSubmitting}
						>
							<BusyIndicator region={REGIONS.DELETE_CUSTOMER_USER}>
								Delete User
							</BusyIndicator>
						</Button>
					</>
				}
				reset={resetModal}
				size='md'
				title='Are Your Sure You Want to Delete This User?'
			>
				<form onSubmit={form.handleSubmit(onSubmit)} className='f-14'>
					<div className={'form-group'}>
						<h6 className='mb-25'>
							Please confirm deletion by typing the users name.
						</h6>
						<TextField label={`Type "${selectedUser.userName}"`} name='userName' />
					</div>
					<div className={'form-group'}>
						<SelectField
							label='Move Assignment To:'
							name='moveAssignment'
							placeholder='unassigned'
							options={moveAssignmentTo.map((each) => ({ label: each.userName, value: String(each.id) }))}
						/>
					</div>
				</form>
			</Modal>
		</Form>
	)
}
export default DeleteUserModal
